import { Controller } from "@hotwired/stimulus"

// One meal row on the day view.
//
// One job now: letting a touch swipe reach the same actions a pointer gets
// on hover. It used to open an adjust panel too, until that panel became a
// stepper that is simply always there.
export default class extends Controller {

  // --- Swipe ------------------------------------------------------------
  //
  // A swipe left on a touch device reveals the row's controls, which a
  // pointer gets on hover. Never the ONLY way to reach an action: every
  // control it uncovers is a real button that keyboard and pointer already
  // reach, because an action available only by swipe is an action a keyboard
  // cannot perform.

  connect() {
    this.startX = null
    this.startY = null
  }

  start(event) {
    const touch = event.changedTouches?.[0]
    if (!touch) return

    this.startX = touch.clientX
    this.startY = touch.clientY
  }

  move(event) {
    if (this.startX === null) return

    const touch = event.changedTouches?.[0]
    if (!touch) return

    const dx = touch.clientX - this.startX
    const dy = touch.clientY - this.startY

    // Vertical wins: the page scrolls, and a list you cannot scroll past
    // because every row is grabbing at your finger is worse than no swipe
    // at all.
    if (Math.abs(dy) > Math.abs(dx)) return this.reset()

    if (dx < -SWIPE_THRESHOLD) this.element.classList.add("is-swiped")
    if (dx > SWIPE_THRESHOLD) this.element.classList.remove("is-swiped")
  }

  end() {
    this.startX = null
    this.startY = null
  }

  reset() {
    this.startX = null
    this.startY = null
  }
}

// Far enough to be deliberate, short enough to be easy. Below this a swipe
// is indistinguishable from a tap that moved.
const SWIPE_THRESHOLD = 40
